// 西语
export default {
  readMore: 'Leer más',
  startForFree: 'Prueba Gratuita Inmediata',
  required: '{name}No puede estar vacío',
  tryForFree: 'Prueba gratuita',
  CarouselTitle: 'empodera a las empresas globales, ayudando a las empresas a lograr un desarrollo constante.',
  publicConsultation: {
    title1: ' Cloudun ',
    title2: 'AI SaaS',
    title3: 'Consultoría y Experiencia de',
    item1: 'Anuncios AI',
    item2: 'EKYC',
    item3: 'Robot Luna AI',
    item4: 'Servicios antifraude',
    item5: 'Servicios de puntuación de crédito',
    productGroup: 'El producto que quiere consultar es',
    submitTip: 'Al enviar el formulario, usted acepta que Cloudun y sus socios autorizados pueden contactarlo a través de la información de contacto que proporcione, y que los datos solo se utilizarán para la comunicación con usted.',
    form: {
      product: 'producto',
      companyName: 'Nombre de la Empresa',
      contactPersonName: 'Nombre de la Persona de Contacto',
      contactPersonPhone: 'Número de Teléfono del Contacto',
      descriptionOfNeeds: 'Descripción de las Necesidades'
    }
  },
  home: {
    title1: 'AI IMPULSA',
    title2: 'Finanzas Digitales En La Nueva Era',
    EKYC: {
      title1: 'con capacidades de antifraude visual',
      title2: 'Servicios EKYC ',
      ProductTitle1: 'Reconocimiento de documentos',
      ProductSubTitle1: 'Reconocimiento preciso de más de cien tipos de documentos de más de diez países principales, registro de documentos rápido, fluido, eficiente y completo.',
      ProductTitle2: 'Detección de vida',
      ProductSubTitle2: 'Verificación rápida de si el usuario es una operación humana real, prevención eficaz de múltiples ataques de fraude.',
      ProductTitle3: 'Detección facial avanzada',
      ProductSubTitle3: 'Capacidades avanzadas de búsqueda y comparación visual de rostros en la base de datos, exploración de información más oculta del usuario.',
      ProductTitle4: 'Detección de fraude EKYC',
      ProductSubTitle4: 'Reconocimiento preciso de más de diez tipos de fraude de documentos y más de diez tipos de comportamiento de fraude de vida, protección de su negocio contra riesgos de fraude.'
    },
    creditScore: {
      title1: 'preciso basado en big data masiva,',
      title2: 'Modelo de puntuación de crédito ',
      title3: 'que protege el ascenso estable del negocio',
      ProductTitle1: 'Lista negra',
      ProductSubTitle1: 'Base de datos masiva que cubre más de diez países principales de finanzas digitales globales, bloqueo eficaz de usuarios de baja calidad, mejora rápida del rendimiento del negocio.',
      ProductTitle2: 'Auditoría previa',
      ProductSubTitle2: 'Auditoría inicial rápida del crédito del usuario basada en los tres elementos de autenticación, lo que ayuda al negocio a ahorrar costos de llamadas ineficaces a terceros en procesos posteriores.',
      ProductTitle3: 'Auditoría integral',
      ProductSubTitle3: 'Establecimiento de un modelo multidimensional basado en decenas de miles de puntos de características, reconocimiento eficaz de riesgos, cálculo preciso del crédito del usuario.',
      ProductTitle4: 'Cálculo de límite',
      ProductSubTitle4: 'Cálculo científico del límite de crédito efectivo del usuario, reducción de riesgos y aumento rápido de las ganancias del negocio por transacción.'

    },
    antiFraud: {
      title1: 'Iteración continua para mantener las',
      title2: ' capacidades antifraude ',
      title3: 'de vanguardia de la industria, un paso por delante',
      ProductTitle1: 'Detección de fraude EKYC',
      ProductTitle2: 'Antifraude de dispositivos móviles',
      ProductTitle3: 'Antifraude de IP',
      ProductTitle4: 'Antifraude de tarjetas bancarias',
      standardProduct: 'Antifraude de ubicación GPS'
    },
    lunaAI: {
      title1: 'Robot de llamadas de voz Luna AI ',
      title2: 'La mejor manera de llegar a los clientes de manera eficiente en la nueva era',
      repaymentAITitle: 'Robot de llamadas de voz AI para recordatorios de pago',
      repaymentAIText: 'Basándose en los servicios del centro de contacto en la nube inteligente de Cloudun y un robot de IA con guiones de estrategia de pago de alto rendimiento de aprendizaje profundo, le proporcionamos una solución de llamadas de voz inteligentes integral para mejorar las tasas de pago.',
      customerServiceAITitle: 'Robot de llamadas de voz AI de servicio al cliente',
      customerServiceAIText: 'Basándose en la base de conocimientos y los procesos comerciales de su empresa, personalizamos un sistema de servicio al cliente de IA único para su empresa, abriendo una nueva era de servicio inteligente en línea las 24 horas.',
      marketingAITitle: 'Robot de llamadas de voz AI de marketing',
      marketingAIText: 'Asiento de llamadas de voz de marketing de IA, que permite a los clientes empresariales realizar la gestión del valor del ciclo de vida completo del usuario, potenciando el marketing inteligente del ciclo de vida completo del cliente.',
      multilingualAITitle: 'Robot de llamadas de voz AI multilingüe',
      multilingualAIText: 'Obtenga al instante su propio personal de llamadas de voz de diálogo de IA localizado y similar al humano.',
      LLMVoiceTitle: 'Experto en diálogo de voz de modelo grande',
      LLMVoiceText: 'Basándose en LLM para reconocer con precisión la intención del usuario y generar voz de chat en tiempo real basada en una biblioteca de guiones de chat de alta calidad, establezca su grupo de asientos de comunicación avanzada de negocios y convierta a los usuarios de manera eficiente.',
      intelligentContactTitle: 'Plataforma de comunicación del centro de contacto inteligente',
      intelligentContactText: 'Plataforma de comunicación rica en recursos, que establece un canal estable y confiable para que usted llegue a los usuarios.'
    },
    overseasMarket: {
      title1: 'Equipo profesional de de gestión de publicidad en el extranjero, ',
      title2: 'que le brinda una aceleración 10 veces mayor en la publicidad y un crecimiento de tráfico 10 veces mayor.',
      applicationMarketTitle: 'Optimización Inteligente de la Tienda de Aplicaciones',
      applicationMarketText: 'Diseñadores profesionales y equipos de operaciones personalizan el diseño de la tienda de aplicaciones para su aplicación, desde la carga de videos hasta las operaciones de comentarios gráficos, asumiendo el tráfico y mejorando la conversión de descargas.',
      investmentFlowTitle: 'Contenidos Publicitarios AIGC para el Mercado Extranjero',
      investmentFlowText: 'La creación rápida de una gran cantidad de videos y materiales gráficos de alta calidad para la distribución de tráfico con potentes capacidades de generación multimedia AIGC. Reducir drásticamente los costos de creación de contenido publicitario y iniciar una nueva era de adquisición de tráfico internacional con alta calidad y volumen.',
      majorTitle: 'Servicios de Publicidad Profesional en el Extranjero',
      majorText: 'Nuestro equipo de expertos aprovecha las plataformas globales para ofrecer una adquisición masiva de usuarios y mejoras en el ROI.'
    },
    solution: {
      title: 'Asóciese con nosotros para un crecimiento rentable',
      item1Title: 'Solución Integral de Préstamos en Línea',
      item1Text: 'Desde la consultoría, el establecimiento del modelo de negocio, el desarrollo e implementación personalizados, hasta la orientación operativa y el análisis operativo en la etapa inicial del negocio, y finalmente la transferencia completa de la estrategia operativa y el código, para lograr soluciones comerciales integrales.',
      item2Title: 'Solución Integral de Adquisición de Usuarios en el Mercado Extranjero',
      item2Text: 'Desde la optimización de la tienda de aplicaciones, hasta la producción de material multimedia publicitario, y finalmente a los servicios de un equipo publicitario profesional para obtener una adquisición masiva de usuarios.'
    },
    ISOAuthentication: {
      title: 'Certificaciones Globales',
      item1: 'Cloudun AI ha obtenido la certificación internacional autorizada ISO27001, posee un sistema de gestión de riesgos que cubre todo el proceso de seguridad de la información, demostrando capacidades integrales desde la protección de datos hasta las operaciones conformes. Garantizamos la seguridad de su privacidad y secretos comerciales con estándares líderes a nivel mundial, ayudando a su empresa a cumplir fácilmente con las estrictas regulaciones internacionales como GDPR.',
      subTitle: 'Certificado de Registro de Derechos de Autor de Software Informático',
      item2: 'Cloudun AI ha obtenido cerca de 20 certificados de registro de derechos de autor de software informático, realizando la construcción y protección de propiedad intelectual independiente que cubre áreas centrales como algoritmos centrales de control de riesgos, computación de big data y reconocimiento de vistas CV. Estos logros tecnológicos brindan un fuerte apoyo a las actualizaciones digitales de los clientes, garantizando el funcionamiento continuo, seguro y estable de los sistemas empresariales.',
      certificate2: 'Certificado de Registro de Derechos de Autor de Software Informático'
    },
    businessMap: {
      title: 'Países a los que prestamos servicios'
    },
    startFor: {
      title: 'Experimente la plataforma SaaS de Cloudun',
      subTitle: 'Acelere su negocio'
    }
  },
  EKYC: {
    slogan1: 'Con Capacidades Antifraude Visual',
    slogan2: 'EKYC',
    subSlogan: 'Ofrezca a los clientes una experiencia de autenticación más fluida y a las empresas datos de autenticación EKYC más confiables.',
    trialGuidance: 'Experimente un EKYC fluido con capacidades antifraude',
    IDDetect: {
      title: 'Reconocimiento de documentos',
      introduction: 'Reconocimiento preciso de más de cien tipos de documentos de más de diez países principales, registro de documentos rápido, fluido, eficiente y completo.',
      introductionItem1: 'Solución SDK de cliente madura, integración rápida;',
      introductionItem2: 'Experiencia de interacción definitiva, mayor tasa de conversión de clientes;',
      introductionItem3: 'Soporte para todos los tipos de documentos en todos los países, con una tasa de reconocimiento de hasta el 99,9%'
    },
    livenessDetect: {
      title: 'Detección de vida',
      introduction: 'Verificación rápida de si el usuario es una operación humana real, prevención eficaz de múltiples ataques de fraude.',
      introductionItem1Title: 'Fácil de usar',
      introductionItem1Text: 'experiencia de interacción definitiva, el usuario completa la autenticación sin problemas',
      introductionItem2Title: 'Integración rápida',
      introductionItem2Text: 'interfaz de autenticación de proceso completo completa, sin necesidad de desarrollo frontend.',
      introductionItem3Title: 'Soporte multiplataforma',
      introductionItem3Text: 'iOS SDK, Android SDK, web H5, soporte integral para sus productos de múltiples formas'
    },
    faceDetect: {
      title: 'Detección facial avanzada',
      introduction: 'Capacidades avanzadas de búsqueda y comparación visual de rostros en la base de datos, exploración de información más oculta del usuario.',
      introductionItem1Title: 'Capacidad de comparación de persona y documento',
      introductionItem1Text: 'basada en la tecnología de reconocimiento y comparación facial, haga coincidir la selfie del usuario con la foto de su documento para verificar la consistencia de la identidad del solicitante',
      introductionItem2Title: 'Capacidad de consulta de rostros en la base de datos',
      introductionItem2Text: ' recupere si existe información histórica de rostros del usuario en la base de datos (información histórica de ID, solicitud, estado de pago)'
    },
    fraudDetect: {
      title: 'Detección de fraude EKYC',
      introduction: 'Reconocimiento preciso de más de diez tipos de fraude de documentos y más de diez tipos de comportamiento de fraude de vida, protección de su negocio contra riesgos de fraude.',
      exampleItem1: 'Detección de reproducción de rostros en pantalla',
      exampleItem2: 'Detección de manchas faciales',
      exampleItem3: 'Detección de expresiones faciales exageradas',
      exampleItem4: 'Detección de reemplazo de fondo con IA',
      exampleItem5: 'Detección de rostros AIGC',
      tip: 'Las imágenes de ejemplo de fraude anteriores han sido desensibilizadas'
    },
    feature: {
      featureItem1Label: 'Número de llamadas procesadas',
      featureItem1Value: '200.000.000+',
      featureItem2Label: 'Número de países cubiertos',
      featureItem2Value: '8+',
      featureItem3Label: 'Número de tipos de documentos admitidos por OCR',
      featureItem3Value: '50+'
    }
  },
  creditScore: {
    slogan1: 'PUNTUACIÓN DE CRÉDITO CLOUDUN PARA',
    slogan2: 'Impulsar El Crecimiento Estable Del Negocio',
    subSlogan: 'Basándose en datos masivos y utilizando modelos multidimensionales de control de riesgos para obtener información precisa sobre el crédito, ayudando a las empresas a reducir los riesgos y aumentar rápidamente las ganancias del negocio por transacción.',
    trialGuidance: 'Únase a muchas empresas avanzadas para mejorar el rendimiento con modelos de big data de control de riesgos',
    blacklist: {
      title: 'Lista negra',
      introduction: 'Base de datos masiva que cubre más de diez países principales de finanzas digitales globales, bloqueando eficazmente a los usuarios de baja calidad y mejorando rápidamente el rendimiento del negocio.'
    },
    preAudit: {
      title: 'Auditoría previa',
      introduction: 'Auditoría inicial rápida del crédito del usuario basada en los tres elementos de autenticación, ayudando a las empresas a ahorrar costos de llamadas ineficaces a terceros en procesos posteriores.'
    },
    audit: {
      title: 'Revisión integral',
      introduction: 'Modelo multidimensional basado en más de 20.000 puntos de características, que identifica eficazmente los riesgos y calcula con precisión el crédito del usuario.'
    },
    amountLimit: {
      title: 'Cálculo de límite',
      introduction: 'Cálculo científico del límite de crédito efectivo del usuario, reduciendo el riesgo y aumentando rápidamente las ganancias del negocio por transacción.'
    },
    feature: {
      featureItem1Label: 'Países atendidos',
      featureItem1Value: '8+',
      featureItem2Label: 'Proyectos atendidos',
      featureItem2Value: '100+',
      featureItem3Label: 'Llamadas a la API',
      featureItem3Value: '160 millones+',
      featureItem4Label: 'Monto del préstamo',
      featureItem4Value: '$5 mil millones+',
      featureItem5Label: 'Iteraciones del modelo',
      featureItem5Value: '500+',
      featureItem6Label: 'Recuento de características',
      featureItem6Value: '200.000+'
    }
  },
  antiFraud: {
    slogan1: 'ANTIFRAUDE DE IA',
    slogan2: 'Un Paso Adelante',
    subSlogan: 'Iteración continua para mantener las capacidades antifraude de vanguardia de la industria, un paso por delante.',
    trialGuidance: 'Acceda a Cloudun antifraude para proteger su negocio',
    functionIntroduction: 'Frente a los métodos de fraude emergentes en el mercado, Cloudun, basándose en el uso de tecnología de big data, extrae características de la información ingresada por el usuario y la información del dispositivo del usuario, e identifica de manera integral el fraude de documentos de grupos de fraude, el cepillado de pedidos agrupados por equipos de fraude y otros comportamientos para proteger la seguridad de su negocio.',
    feature: {
      featureItem1Label: 'Volumen de llamadas',
      featureItem1Value: '10,000,000+',
      featureItem2Label: 'Tasa de identificación de usuarios fraudulentos',
      featureItem2Value: '95+%',
      featureItem3Label: 'Usuarios fraudulentos identificados',
      featureItem3Value: '1,000,000+',
      featureItem4Label: 'Modelos antifraude de desarrollo propio implementados',
      featureItem4Value: '20+'
    }
  },
  lunaAi: {
    slogan1: 'ROBOT DE VOZ LUNA AI',
    subSlogan: 'Personal de llamadas de voz de AI, la mejor manera de llegar a los clientes de manera eficiente en la nueva era.',
    subTag1: 'Comunicación conversacional para mejorar la conversión',
    subTag2: 'Voz altamente humana para ser más amigable',
    subTag3: 'Plataforma de comunicación de alta confiabilidad',
    trialGuidance: 'Experimente la nueva era de la comunicación con el cliente',
    repaymentReminder: {
      title: 'Robot de llamadas de voz AI para recordatorios de pago',
      introduction: 'Basándose en los servicios del centro de contacto en la nube inteligente de Cloudun y un robot de AI con guiones de estrategia de pago de alto rendimiento de aprendizaje profundo, le proporcionamos una solución de llamadas de voz inteligentes integral para mejorar las tasas de pago.',
      introductionItem1: 'Asesor de AI personalizado: establezca con precisión el estilo de idioma, el tono de voz y el tono de comunicación',
      introductionItem2: 'Adapte múltiples estrategias de recordatorio de pago para que coincidan profundamente con los métodos de recordatorio para las diferentes etapas de pago del cliente.',
      introductionItem3: 'Desarrolle estrategias integrales de llamadas para mejorar eficazmente las tasas de pago integrales del negocio y permitir la gestión inteligente de pagos.'
    },
    customerService: {
      title: 'Robot de llamadas de voz AI de atención al cliente',
      introduction: 'Basándose en la base de conocimientos y los procesos comerciales de su empresa, personalizamos un sistema de servicio al cliente de AI único para su empresa, abriendo una nueva era de servicio inteligente en línea todas las horas.',
      introductionItem1Title: 'Servicio ininterrumpido las 24 horas',
      introductionItem1Text: 'servicio continuo en las 24 horas.',
      introductionItem2Title: 'Aprendizaje inteligente y adaptación',
      introductionItem2Text: 'evolución del aprendizaje inteligente.',
      introductionItem3Title: 'Experiencia de servicio personalizada',
      introductionItem3Text: 'experiencia de servicio considerada.'
    },
    marketing: {
      title: 'Robot de llamadas de voz AI de marketing',
      introduction: 'Obtenga al instante su propio personal de llamadas de voz de diálogo de IA localizado y similar al humano.',
      introductionItem1: 'Interacción de voz inteligente 1v1: comprenda con precisión la intención del cliente, aproveche con precisión las oportunidades de marketing e impulse la conversión del cliente.',
      introductionItem2: 'Modelos de marketing de ciclo de vida completo: cubren la inteligencia de llamadas automatizadas y la biblioteca de guiones de diálogo para toda la cadena de generación de prospectos, seguimiento, conversión y recompra, reconstruyendo un nuevo modelo para el crecimiento empresarial.',
      introductionItem3: 'Biblioteca de guiones de diálogo de expertos de aprendizaje: admite la carga de la base de conocimientos de expertos en marketing internos de la empresa, absorbiendo rápidamente la esencia de los guiones de diálogo principales.'
    },
    multilingual: {
      title: 'Experto en voz AI multilingüe',
      introduction: 'Obtenga en un minuto su propio personal de asiento de AI de diálogo altamente humano que utiliza su idioma nativo',
      introductionItem1Title: 'Diálogo altamente humano',
      introductionItem1Text: 'acumule una rica tecnología de lenguaje, utilice tecnologías avanzadas como la interrupción inteligente y la continuación del tono para hacer que el personal de IA se comunique de manera más inteligente y cercana a los métodos de comunicación humana, optimizando la experiencia de diálogo. Los tonos de voz ricos son más realistas, lo que hace que los usuarios se sientan amigables y reduce las desconexiones.',
      introductionItem2Title: 'Creación rápida',
      introductionItem2Text: 'ha acumulado plantillas de robots de voz AI multilingües, que se pueden poner en produción inmediatamente.'
    },
    largeModel: {
      title: 'Experto en diálogo de voz de modelo grande',
      introduction: 'Basándose en LLM para aprender rápidamente guiones de conversación de alta calidad y reconocer con precisión la intención del usuario, construya su grupo de asientos de comunicación avanzada de negocios y convierta a los usuarios de manera eficiente.',
      introductionItem1Title: 'Reconocimiento preciso de la intención del usuario',
      introductionItem1Text: 'basado en modelos de lenguaje grande, reconoce con precisión la intención del usuario, proporcionando un fuerte apoyo para la conversión del comportamiento del cliente y mejorando significativamente la eficacia del negocio.',
      introductionItem2Title: 'Generación inteligente de guiones de diálogo de expertos',
      introductionItem2Text: 'basándose en modelos de lenguaje grande avanzados, extrae la esencia de guiones de alta calidad masivos, en direcciones como "recordatorios de pago", "servicio al cliente inteligente" y "promoción de marketing", combinando información personalizada del usuario y expresión de intención, genera instantáneamente guiones de comunicación específicos y profesionales, optimizando integralmente el efecto de la comunicación con el cliente.'
    },
    contactCenter: {
      title: 'Plataforma de comunicación del centro de contacto inteligente',
      introduction: 'Plataforma de comunicación rica en recursos, que establece un servicio estable y confiable para que usted llegue a los usuarios',
      introductionItem1Title: 'Recursos ricos',
      introductionItem1Text: 'recopila recursos de comunicación de alta calidad y abundantes en el extranjero',
      introductionItem2Title: 'Plataforma estable',
      introductionItem2Text: 'plataforma de acceso de intercambio de comunicación, altamente confiable y estable',
      introductionItem3Title: 'Ahorro de tiempo y esfuerzo',
      introductionItem3Text: 'integración de recursos de múltiples países y redes, acceso API de una sola parada'
    },
    feature: {
      featureItem1Title: 'Integración rápida en el mismo día',
      featureItem1: 'Robots de voz multilingües listos para usar',
      featureItem2: 'Plantillas de reconocimiento de intenciones y diálogo preconstruidas para planes de pago en varios países',
      featureItem3: 'Finalización rápida de la base de conocimientos de servicio al cliente mediante la carga del corpus de servicio',
      featureItem2Title: 'Aumentar la tasa de alcance de usuarios en más del',
      featureItem3Title: 'Aumentar la tasa de pago en más del'
    }
  },
  aiAds: {
    slogan1: 'SERVICIOS DE ANUNCIOS DE AI',
    slogan2: 'Obtenga Tráfico Masivo En El Extranjero',
    subSlogan: 'Junto con el equipo de publicidad de Cloudun, acelere la adquisición de tráfico del mercado extranjero: aceleración de la entrega 10 veces mayor, crecimiento del tráfico 10 veces mayor',
    subTag1: 'Publicar en redes sociales',
    subTag2: 'Producción de material publicitario',
    subTag3: 'Tráfico de la tienda de aplicaciones',
    subTag4: 'Mercado extranjero',
    trialGuidance: 'Obtenga Servicios de Tráfico Masivo Ahora',
    furnish: {
      title: 'Decoración de la tienda de aplicaciones',
      introduction: 'Diseñadores profesionales y equipos de operaciones personalizan el diseño de decoración de la tienda de aplicaciones para su aplicación, desde la carga de videos hasta la operación de comentarios gráficos, aceptando tráfico para aumentar la conversión de descargas.',
      introductionItem1: 'Logotipo de la aplicación, imágenes en App Store, videos y subtítulos adaptados (diseño de UI y AIGC)',
      introductionItem2: 'Equipo profesional 1v1 para servirle'
    },
    material: {
      title: 'Producción de material de entrega de tráfico inteligente en el mercado extranjero',
      introduction: 'Con potentes capacidades de generación AIGC multimedia, genere rápidamente una gran cantidad de videos y materiales gráficos de tráfico de alta calidad. Reduzca en gran medida los costos de producción de contenido publicitario y abra una nueva era de adquisición de tráfico en el extranjero de alta calidad y cantidad.',
      introductionItem1: 'Material de video publicitario original de personas digitales AIGC',
      introductionItem2: 'Material de video publicitario de intercambio de caras de personas digitales AIGC',
      introductionItem3: 'Material gráfico publicitario AIGC',
      introductionItem4: 'Soporte para múltiples idiomas'
    },
    feature: {
      featureItem1Label: 'Idiomas de Material Publicitario Admitidos',
      featureItem1Value: '8 Países',
      featureItem2Label: 'Tasa de Conversión de Descargas desde la Tienda de Aplicaciones',
      featureItem2Value: '+50%',
      featureItem3Label: 'ROI Publicitario Aumentado en un',
      featureItem3Value: '30%'
    }
  },
  company: {
    title: 'Cloudun AI Empodera A Las Empresas Financieras Globales',
    submitTitle: 'Aprovechando la tecnología de AI, desarrollado propio, y FinTech, Cloudun empodera a las empresas financieras globales para mejorar la eficiencia de los servicios financieros, brindando mejores productos y servicios financieros a los consumidores.',
    companyHistory: {
      title: 'Soluciones de AI para finanzas digitales Cloudun',
      item2018OneActive: 'Se fundó Fintek, ',
      item2018One: 'dedicada principalmente al desarrollo de SaaS de préstamos.',
      item2019OneActive: 'Cloudun Cayman y Singapur ',
      item2019One: 'se constituyeron en mayo de 2019.',
      item2019Two: 'El grupo comenzó a explorar la tecnología financiera de AI y los ',
      item2019TwoActive: 'servicios tecnológicos en Indonesia.',
      item2020OneActive: 'Se constituyó Cloudun Indonesia, ',
      item2020One: 'comenzó a proporcionar servicios de EKYC, información y revisión crediticia y consultoría de préstamos digitales en Indonesia.',
      item2021OneActive: 'Se estableció Cloudun HK, ',
      item2021One: 'comenzó los negocios en México, expandiendo las líneas de productos: anuncios de AI.',
      item2021Two: 'A finales de 2021, Cloudun ofreció servicios a 67 clientes empresariales, con un volumen de utilización a la API de más de ',
      item2021TwoActive: '90 millones de veces.',
      item2022OneActive: 'Cloudun Group optimiza ',
      item2022One: 'continuamente los productos en los mercados de México e Indonesia, aumenta constantemente los clientes empresariales y mantiene un crecimiento empresarial sostenible. En 2023, la utilización de API alcanzaron los 270 millones de veces ese año.',
      item2022Two: 'Completó la financiación de la Serie A.',
      item2024One: 'Sobre la base de mantener un crecimiento estable en el mercado existente, Cloudun ha explorado horizontalmente en otras regiones como Filipinas y avanza verticalmente en el desarrollo de sistemas de operación inteligentes como el chatbot de AI.',
      item2024Two: 'En diciembre de 2024, Cloudun ha ofrecido servicios a más de 90 clientes empresariales con un volumen de transacciones financieras de más de 5.000 millones de dólares, conectando a casi 50 millones de usuarios finales.',
      item2024Three: 'Nos asociamos con actores clave en toda la cadena industrial, fomentando la colaboración y creando valor compartido.'
    }
  },
  solution: {
    slogan1: 'Asóciese Con Nosotros Para Un Crecimiento Rentable',
    subSlogan: 'Basándonos en el sistema de servicios de ciclo completo, creamos soluciones integrales que abarcan el diseño de alto nivel de los modelos de negocio, el desarrollo y la implantación de sistemas personalizados, la orientación sobre el inicio de negocio, la optimización de las estrategias de operación y la transferencia sistemática de tecnología, con el fin de potenciar el ciclo cerrado de toda la cadena de negocio.',
    businessGrowth: {
      title: 'Crecimiento de negocio y Beneficios',
      subTitle: 'Basándonos en la experiencia madura en la práctica del sector, equipados con un sistema de seguimiento de servicios de ciclo completo y mediante estrategias de optimización de operaciones basadas en datos, garantizamos que nuestros socios logren una transformación del valor empresarial cuantificable.'
    },
    consult: {
      title: 'Consultoría y Transferencia',
      subTitle: 'Entrega completa del código, pensamiento comercial, capacitación en estrategias de gestión de riesgos y enseñanza práctica, para garantizar que nuestros clientes tengan la capacidad de continuar operando el negocio.'
    },
    customization: {
      title: 'Personalización e Implementación',
      subTitle1: 'Soluciones exclusivas personalizadas y orientadas al cliente;',
      subTitle2: 'Control estricto del proceso de implementación para maximizar los beneficios.'
    }
  },
  el: {
    pleaseEnter: 'Por favor, introduzca',
    submit: 'Enviar'
  },
  publicNavigation: {
    navList: {
      item1: 'Inicio',
      item2: 'Productos',
      item3: 'Soluciones',
      item4: 'Acerca de nosotros'
    },
    menuList: {
      item1Title: 'EKYC',
      item1Subtitle: 'Ofrezca a los clientes una experiencia de autenticación más fluida y a las empresas datos de autenticación EKYC más confiables.',
      item2Title: 'Puntuación de crédito Cloudun para',
      item2Subtitle: 'Basándose en datos masivos y utilizando modelos multidimensionales de control de riesgos para obtener información precisa sobre el crédito, ayudando a las empresas a reducir los riesgos y aumentar rápidamente las ganancias del negocio por transacción.',
      item3Title: 'Antifraude de IA',
      item3Subtitle: 'Iteración continua para mantener las capacidades antifraude de vanguardia de la industria, un paso por delante.',
      item4Title: 'Robot de voz Luna AI',
      item4Subtitle: 'Personal de llamadas de voz de AI, la mejor manera de llegar a los clientes de manera eficiente en la nueva era.',
      item5Title: 'Servicios de anuncios de AI',
      item5Subtitle: 'Junto con el equipo de publicidad de Cloudun, acelere la adquisición de tráfico del mercado extranjero: aceleración de la entrega 10 veces mayor, crecimiento del tráfico 10 veces mayor.'
    }
  },
  publicFooter: {
    products: 'Productos',
    product1: 'Anuncios con AI',
    product2: 'EKYC',
    product3: 'Robot Luna AI',
    product4: 'Servicios antifraude',
    product5: 'Servicios de puntuación de crédito',
    solutions: 'Soluciones',
    solutions1: 'Solución Integral de Préstamos en Línea',
    solutions2: 'Solución Integral de Adquisición de Usuarios en el Mercado Extranjero',
    company: 'Compañía',
    company1: 'Acerca de nosotros',
    contactUs: 'Contáctenos',
    contactUs1: 'Teléfono',
    contactUs2: 'Correo electrónico'
  }
}
